import React from 'react';
import { IconContainer } from './IconContainer';

const UploadContractsIcon = (props) => {
    return (
        <IconContainer ariaLabel="contracts" cursor="pointer" { ...props }>
            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.8375 1.66669C16.7558 1.66669 17.5 2.41502 17.5 3.32502V16.675C17.5 17.5909 16.7558 18.3334 15.8375 18.3334H2.5V1.66669H15.8375ZM5.83333 3.33335H4.16667V16.6667H5.83333V3.33335ZM15.8333 3.33335H7.5V16.6667H15.8333V3.33335ZM11.6667 6.66669L15 10H12.5V13.3334H10.8333V10H8.33333L11.6667 6.66669ZM20 10V13.3334H18.3333V10H20ZM20 5.00002V8.33335H18.3333V5.00002H20Z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { UploadContractsIcon };